import React from 'react';


const ArrowIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
             key={1}
             version="1.1" x="0px" y="0px" viewBox="0 0 42.652 8.608" width="36px" height="8px"
             enableBackground="new 0 0 42.652 8.608" xmlSpace="preserve">
            <rect x="-0.038" y="3.875" width="41.656" height="1.03"></rect>
            <rect x="37.092" y="2.002" transform="matrix(0.7071 0.7071 -0.7071 0.7071 13.5355 -27.6438)" width="6.089"
                  height="1.031"></rect>
            <rect x="37.092" y="5.575" transform="matrix(0.707 -0.7072 0.7072 0.707 7.4515 30.1683)" width="6.088"
                  height="1.031"></rect>
        </svg>

    )

}


export default ArrowIcon;
